






















































































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { PrintAreaCustomization, WarehouseItemCustomization } from "@/models";
import { PrintAreaCustomizationMixinTags } from "@/mixins/http/PrintAreaCustomizationMixin";
import Asset from "@/models/Asset";
import DotLoader from "@/components/Common/DotLoader.vue";
import { isMobile } from "@/helpers/mediaQueryHelper";
import { customizationStore, routingStore, httpStore,onboardingStore } from "@/store/typed";
import { bus } from "@/main";
import { v1 as uuid } from "uuid";

import { createPopper } from "@popperjs/core";

type CarouselItem = {
  printAreaCustomization: PrintAreaCustomization;
  warehouseItemCustomization: WarehouseItemCustomization;
};

@Component({
  components: {
    DotLoader,
  },
})
export default class BottomBar extends Vue {
  @Prop({ required: true }) readonly value!: PrintAreaCustomization;
  private printAreaCustomization: PrintAreaCustomization = this.value;

  private popperInstance = null;

  @Watch("value")
  onValueChanged(value: PrintAreaCustomization) {
    this.printAreaCustomization = value;
  }

  get currentPrintAreaCustomizationIndex() {
    return this.carouselItems.findIndex(
      (o: any) =>
        o.printAreaCustomization.id === this.printAreaCustomization?.id
    );
  }

  get customizationStep() {
    const items = customizationStore.printAreaCustomizations;
    const index = this.currentPrintAreaCustomizationIndex;
    return `${index + 1}/${items?.length}`;
  }

  get moreThanOnePrintArea() {
    return customizationStore.printAreaCustomizations.length > 1;
  }

  get warehouseItemCustomizations() {
    return customizationStore.warehouseItemCustomizations;
  }

  get isMobile(): boolean {
    return isMobile((this as any).$mq);
  }

  get displayOnboarding() {
    return onboardingStore.onboarding;
  }

  get warehouseItem() {
    return customizationStore.warehouseItem;
  }

  get currentObjectDescription() {
    return `${customizationStore?.currentWarehouseItemCustomization?.warehouseItem?.name} - ${customizationStore?.currentPrintAreaCustomization?.printArea?.name}`;
  }

  get asset(): Asset {
    return this.warehouseItem?.warehouseItemArtifact?.artifact?.asset || null;
  }

  get updateable() {
    return customizationStore.updateable;
  }

  get showRecapButton(): boolean {
    return (
      this.currentPrintAreaCustomizationIndex === this.carouselItems.length - 1
    );
  }

  get carouselItems(): CarouselItem[] {
    const items: CarouselItem[] = [];
    this.warehouseItemCustomizations.forEach(
      (wic: WarehouseItemCustomization) => {
        wic.printAreaCustomizations.forEach((pac: PrintAreaCustomization) => {
          items.push({
            warehouseItemCustomization: wic,
            printAreaCustomization: pac,
          });
        });
      }
    );

    return items;
  }

  get navigationLocked(): boolean {
    return customizationStore.navigationLocked;
  }

  get showLoader() {
    return httpStore.status[PrintAreaCustomizationMixinTags.UploadAsync]
      ?.loading;
  }

  get canLoadPreviousItem(): boolean {
    return (
      !this.navigationLocked &&
      !this.displayOnboarding &&
      !this.showLoader &&
      this.currentPrintAreaCustomizationIndex > 0
    );
  }

  get canLoadNextItem() {
    return (
      !this.navigationLocked && !this.displayOnboarding && !this.showLoader
    );
  }

  get allItemsConfigured(): boolean {
    return customizationStore.allItemsConfigured;
  }

  showItemNotCompletedTooltip() {
    const popcorn = document.getElementById("go-to-recap-button");
    const tooltip = document.getElementById("tooltip");
    if (!this.popperInstance) {
      this.popperInstance = createPopper(popcorn, tooltip, {
        placement: "top-start",
        modifiers: [
          {
            name: "offset",
            options: {
              offset: [0, 10],
            },
          },
        ],
      });
    }
    tooltip.setAttribute("data-show", "");
  }

  hideItemNotCompletedTooltip() {
    const tooltip = document.getElementById("tooltip");
    tooltip?.removeAttribute("data-show");
  }

  private goToRecap() {
    if (!this.allItemsConfigured) {
      this.showItemNotCompletedTooltip();
      return;
    } else {
      this.onBusEventCompleted(() => routingStore.goToRecap());
    }
  }

  onBusEventCompleted(func) {
    const id = uuid();
    bus.$on("uploadedSvg" + id, (loaded) => {
      func();
      bus.$off();
    });
    bus.$emit("uploadSvg", id);
  }

  loadPreviousItem() {
    this.hideItemNotCompletedTooltip();
    if (!this.canLoadPreviousItem) {
      return;
    }

    this.onBusEventCompleted(() => {
      const item =
        this.carouselItems[this.currentPrintAreaCustomizationIndex - 1];
      customizationStore.setWarehouseItemCustomization(
        item.warehouseItemCustomization
      );
      customizationStore.setPrintAreaCustomization(item.printAreaCustomization);
    });
  }

  switchTo3D() {
    this.$emit("preview", "3d");
  }

  loadNextItem() {
    if (!this.canLoadNextItem) {
      return;
    }

    this.onBusEventCompleted(() => {
      const item =
        this.carouselItems[this.currentPrintAreaCustomizationIndex + 1];
      customizationStore.setWarehouseItemCustomization(
        item.warehouseItemCustomization
      );
      customizationStore.setPrintAreaCustomization(item.printAreaCustomization);
    });
  }

  destroyed() {
    bus.$off();
  }
}
